import { render } from "./HelperIcons.vue?vue&type=template&id=74b06952"
import script from "./HelperIcons.vue?vue&type=script&lang=js"
export * from "./HelperIcons.vue?vue&type=script&lang=js"

import exportComponent from "E:\\ALCON\\_DEV\\dhs-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__